import { runTransaction } from 'firebase/firestore';
import isEqual from 'lodash/isEqual';
import { bindConfigurationField } from './dataFieldBinding';
import { findDataFieldCandidate, readDataFieldRegistration, writeDataFieldRegistration } from './dataFieldRegistration';

const storedFields = ({ id, createdAt, updatedAt, ...data }) => data;

// Compare stored content, not just version metadata: legacy writers may
// change a layout without incrementing its version. Firestore retries the read
// and comparison if another writer commits before this transaction does. The
// server-generated timestamps are excluded so a successful save can become
// the next baseline without adopting another writer's later changes.
// Optional registration is committed with the item, so retries cannot leave a
// saved item without its registry entry. Preserve existing auto-ID/legacy rows.
// New fields use the already-supported field-name ID so concurrent creators
// contend on the same document instead of adding duplicate registry entries.
export async function saveConfigurationRevision(db, ref, expected, updates, options = {}) {
  const { dataField, create = false, duplicateMessage } = options;
  const fieldRef = await findDataFieldCandidate(db, dataField);

  return runTransaction(db, async transaction => {
    if (create || expected) {
      const snapshot = await transaction.get(ref);
      if (create && snapshot.exists()) {
        throw new Error(duplicateMessage);
      }
      if (!create && (!snapshot.exists() || !isEqual(storedFields(snapshot.data()), storedFields(expected)))) {
        throw new Error('This item changed since you opened it. Copy your changes, then reopen it and try again.');
      }
    }
    const registration = await readDataFieldRegistration(transaction, db, dataField, fieldRef);
    const boundUpdates = bindConfigurationField(updates, dataField?.fieldKey, registration?.ref);
    if (create) transaction.set(ref, boundUpdates);
    else transaction.update(ref, boundUpdates);
    writeDataFieldRegistration(transaction, registration, dataField);
  });
}
